import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BsHexagon, BsHexagonFill } from 'react-icons/bs';
import { FaICursor } from 'react-icons/fa';
import { IoSearchOutline } from 'react-icons/io5';
import { TbBinaryTree } from 'react-icons/tb';
import { useChartData } from '../../context/ChartContext';
import { useDispatch } from '../../context/DispatchContext';
import { CounterLabel } from '../../elements/CounterLabel';
import Input from '../../elements/Input';
import { PreferencesButton } from '../../elements/PreferencesButton';
import Select from '../../elements/Select';
import { ToolBarButton } from '../../elements/ToolBarButton';
import useToolsFunctions from '../../hooks/useToolsFunctions';
import { options } from '../../toolbar/ToolTypes';
import { formatCounterLabel } from '../header/DefaultPanelHeader';
import PanelHeader from '../header/PanelHeader';
export function DatabaseSearchOptions({ databases, defaultDatabase, keywords, result, idCode, total, onKeywordsChange, onSettingClick, onStructureClick, onDatabaseChange, }) {
    const { handleChangeOption } = useToolsFunctions();
    const { view: { spectra: { showSimilarityTree }, }, toolOptions: { selectedTool }, } = useChartData();
    const dispatch = useDispatch();
    function enableFilterHandler(flag) {
        const tool = !flag ? options.zoom.id : options.databaseRangesSelection.id;
        handleChangeOption(tool);
    }
    function handleSearch(input) {
        if (typeof input === 'string' || input === -1) {
            const solvent = String(input);
            onKeywordsChange({ solvent });
        }
        else {
            onKeywordsChange({
                searchKeywords: input.target.value,
            });
        }
    }
    function clearHandler() {
        onKeywordsChange({ searchKeywords: '' });
    }
    function handleShowSimilarityTree() {
        dispatch({ type: 'TOGGLE_SIMILARITY_TREE' });
    }
    return (_jsxs(PanelHeader, { style: { flexDirection: 'column', alignItems: 'normal' }, children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingBottom: '2px',
                }, children: [_jsx(ToolBarButton, { tooltip: `${showSimilarityTree ? 'Hide' : 'Show'} similarity tree`, icon: _jsx(TbBinaryTree, {}), active: showSimilarityTree, onClick: handleShowSimilarityTree }), _jsx(Select, { style: { flex: 6, marginLeft: '5px' }, items: databases, itemTextField: "label", itemValueField: "key", onChange: onDatabaseChange, placeholder: "Select database", defaultValue: defaultDatabase }), _jsx(Select, { style: { flex: 4, margin: '0px 5px' }, items: result.solvents, placeholder: "Solvent", onChange: handleSearch, value: keywords.solvent }), _jsxs("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            flex: 2,
                            justifyContent: 'flex-end',
                        }, children: [_jsx(CounterLabel, { value: formatCounterLabel(total || 0, result.data.length) }), _jsx(PreferencesButton, { tooltip: "Preferences", onClick: onSettingClick })] })] }), _jsxs("div", { style: { display: 'flex', justifyContent: 'space-between' }, children: [_jsx(ToolBarButton, { tooltip: "Filter by select ranges", icon: _jsx(FaICursor, {}), active: selectedTool === options.databaseRangesSelection.id, onClick: enableFilterHandler }), _jsx(Input, { value: keywords.searchKeywords, renderIcon: () => _jsx(IoSearchOutline, {}), style: { inputWrapper: { flex: 3, margin: '0 5px' } }, className: "search-input", type: "text", debounceTime: 250, placeholder: "Search for parameter...", onChange: handleSearch, onClear: clearHandler, canClear: true }), _jsx(ToolBarButton, { tooltip: "Search by substructure", icon: !idCode ? _jsx(BsHexagon, {}) : _jsx(BsHexagonFill, {}), intent: "success", active: !!idCode, onClick: onStructureClick })] })] }));
}
